import { useReferralStore } from '../../ReferralProvider';
import styles from './index.module.scss';
import RewardsBox from './RewardsBox';
import StepsTab from './StepsTab';

export default function MyRewards() {
    const { isLogin } = useReferralStore();

    return (
        <div className={`${styles.MyRewardsWrapper}`}>
            {isLogin && <RewardsBox />}
            <StepsTab />
        </div>
    );
}
